export default __webpack_public_path__ + "static/media/Jenia.180edf99.jpg";